import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import Utils from '../utils/utils';
import { stopClickReachingOverlay } from '../utils/overlay-click';
import { Link } from "react-router-dom";
import Invoice from '../components/invoice';
import GraphLine from '../components/graph-line';
import Modal from '../components/modal';
import FormSelectUser from '../components/form-select-user';
import Checkbox from '../components/checkbox';
import withRouter from '../components/withRouter';
import Select from 'react-select';

import iconSpeaker from '../assets/img/icon-speaker.svg';
import iconHelp from '../assets/img/icon-help.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faCog, faFilter, faSync} from '@fortawesome/free-solid-svg-icons';
import { finalizeSelectedInvoices } from '../utils/invoice-export';
import InvoicePreview from '../components/Invoice-preview';
import axios from "axios";
import AccessControl from '../utils/access_control';

import { fetch } from '../utils/api-wrapper';
import HoverInfoCard from "../components/hover-card";
import DataStore from '../utils/data-store';
import { canOpenInvoiceEditorFromDashboard, getFinalizationErrors, getLastFinalizationError } from '../utils/invoice-status';

/**
 * Returns the value for the Comments column (used in table and in tests).
 * User comments (invoice processing). Errors/workflow live in status_details;
 * a future optional column may display those. Exported for regression tests.
 */
export function getCommentsColumnValue(inv) {
  return inv?.json?.comments ?? "";
}

export function canUseDashboardUserFilter(data) {
    return data?.role !== null && (
        Utils.userHasRole(data, ["Admin", "Manager"]) ||
        AccessControl.hasUniversalProxy(data)
    );
}

export default inject("data")(withRouter(observer(class Dashboard extends Component {

    constructor(props) {
        super(props); 
        this.source =  axios.CancelToken.source();
        const initialVacationMode = this.normalizeVacationMode(props?.data?.vacation_mode);
        let colsToDisplay = ["created_at", "updated_at", "json.ListSupplier[0].Number", "json.ListSupplier[0].Name", "json.InvoiceNo", "status"];

        if (localStorage["colsToDisplay"] != null) {
            colsToDisplay = JSON.parse(localStorage["colsToDisplay"]);
            // Migrate legacy Comments column key so users keep the column visible after switching to json.comments (xpen-1951).
            colsToDisplay = colsToDisplay.map(col => col === "status_details" ? "json.comments" : col);
        }

        this.duplicated_key = [];
        this.exportFormat = "acomba";

        this.columnDragFinal = null;
        this.columnDragInitial = null;
        this.draggable = false;

        this.roleMapping = {
            SuperAdmin: ["SuperAdmin", "Admin", "Manager", "Approver", "Clerk", "Assistant"],
            Admin: ["Admin", "Manager", "Approver", "Clerk", "Assistant"],
            Manager: ["Manager", "Approver", "Clerk", "Assistant"]
        };

        this.availableRoles = [];

        this.state = {
            all_roles: [],
            pageNumber: 1,
            pageCount: 1,
            allInvoices: [],
            invoices: [],
            invoiceSelection: [],
            users: [],
            searchStr: "",
            searchUser: null,
            searchDateMin: "",
            searchDateMax: "",
            searchCreatedDateMin: "",
            searchCreatedDateMax: "",
            validatedSearchStr: "",
            validatedSearchUser: null,
            validatedSearchDateMin: "",
            validatedSearchDateMax: "",
            validatedSearchCreatedDateMin: "",
            validatedSearchCreatedDateMax: "",
            showCompletedInvoices: false,
            currentInvoice: null,
            total: "",
            processingTotal: "",
            monthlyTotals: [],
            actionType: null,
            showConnectAsPrompt: false,
            showChangeClientPrompt: false,
            connectAs: "Clerk",
            connectAsClient: null,
            showAdvancedSearch: false,
            showTableConfig: false,
            columnsToDisplay: colsToDisplay,
            columnsToDisplayTmp: [],
            displayTransfer: false,
            transferring: false,
            deleting: false,
            selectedUser: null,
            exporting : new Set(),
            displayFilterBy: "",
            filterBys: [],              // filters of invoices
            listFilters: [],            // list to contain checked option in filter menu
            choiceListFilter: [],       // displayed choices from the filter menu
            allChoicesListFilter: [],    // all possible choices in the filter menu (to be able to add deleted choices)
            errorMessage: null,
            userHasCreditCards: false,
            creditCards: [],
            showVacationModePrompt: false,
            savingVacationMode: false,
            currentUserVacationMode: initialVacationMode,
            vacationModeForm: initialVacationMode
        }

        this.colsToNotFilter = ["created_at", "updated_at", "billing_date", "total", "preview", "total_with_tax", "comments"];
        this.currentStatus = null;
        this.refreshId = null;
        this.chart = null;
        this.sortedColumn = { "name": "", "sortAsc": true };
        this._isMounted = false;
        this.columnsWithDate = ["updated_at", "created_at", "json.InvoiceDate"];

        this.availableColumns = [
            { "name": "created_at", "evaluate": inv => Intl.DateTimeFormat(`${this.props.data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(inv.created_at)), "displayName": "created_at"},
            { "name": "updated_at", "evaluate": inv => Intl.DateTimeFormat(`${this.props.data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(inv.updated_at)), "displayName": "updated_at"},
            { "name": "json.InvoiceDate", "evaluate": inv => inv.json ? inv.json.InvoiceDate : "", "displayName": "billing_date" },
            { "name": "json.DueDate", "evaluate": inv => inv.json && inv.json.DueDate ? inv.json.DueDate : "", "displayName": "due_date" },
            { "name": "json.ListSupplier[0].Number", "evaluate": inv => inv.json && inv.json.ListSupplier && inv.json.ListSupplier.length > 0 ? inv.json.ListSupplier[0].Number : "", "displayName": "supplier_number" },
            { "name": "json.ListSupplier[0].Name", "evaluate": inv => inv.json && inv.json.ListSupplier && inv.json.ListSupplier.length > 0 ? inv.json.ListSupplier[0].Name : "", "displayName": "supplier_name" },
            { "name": "json.InvoiceNo", "evaluate": inv => inv.json && inv.json.InvoiceNo ? inv.json.InvoiceNo : "", "displayName": "invoice_number" },
            { "name": "json.Currency", "evaluate": inv => inv.json && inv.json.Currency? inv.json.Currency : "", "displayName": "currency" },
            { "name": "status", "evaluate": inv => inv.status, "displayName": "status" },
            { "name": "json.Total", "evaluate": inv => inv.json && inv.json.Total ? "$" + inv.json.Total.toFixed(2) : "", "displayName": "total" },
            { "name": "json.TotalWithTax", "evaluate": inv => inv.json && inv.json.TotalWithTax ? "$" + parseFloat(inv.json.TotalWithTax).toFixed(2) : "", "displayName": "total_with_tax" },
            { "name": "json.GLUnit", "evaluate": inv => inv.json && inv.json.GLUnit ? inv.json.GLUnit : "", "displayName": "unit" },
            { "name": "json.Office", "evaluate": inv => inv.json && inv.json.Office ? inv.json.Office : "", "displayName": "office_header" },
            { "name": "username", "evaluate": inv => inv.username ? inv.username : "", "displayName": "username" },
            { "name": "approver", "evaluate": inv => inv.json && inv.json.approver ? inv.json.approver.first_name + " " + inv.json.approver.last_name  : "", "displayName": "approver" },
            { "name": "preview", "evaluate": inv => inv.file_name ? inv.file_name : `${inv._id}.pdf`, "displayName": "preview"},
            // User comments (invoice processing). Errors/workflow live in status_details; a future optional column may display those.
            { "name": "json.comments", "evaluate": inv => getCommentsColumnValue(inv), "displayName": "comments" },
            { "name": "approval_type", "evaluate": inv => inv.json && inv.json.ListItem && inv.json.ListItem.find(i => i.approver?.username) ? "Multiple" : "Unique", "displayName": "approval_type" },
            { "name": "payment_status", "evaluate": inv => inv.payment ? inv.payment.status: "", "displayName": "payment_status" },
            {"name": "cheque_number", "evaluate": inv => inv.payment ? inv.payment.CheckNumber : "", "displayName": "cheque_number"},
            {"name": "type", "evaluate": inv => inv.type ? this.props.data.t.read(`invoice_types.${(inv.type).toLowerCase()}`) || "AP" : "AP", "displayName": "type"},
        ]
    }

    searchUnit(event) {
        let valueToSearch = event.target.value.toLowerCase();
        let invoicesBody = document.querySelector(".invoices tbody");
        let invoices = invoicesBody.children;
        let indexUnit = this.state.columnsToDisplay.indexOf("json.GLUnit") + 2

        if (invoices.length === 0) return;

        for (var i = 0; i < invoices.length; i++) {
            let el1 = invoices[i].querySelector(`td:nth-child(${indexUnit})`).textContent.toLowerCase();

            if (el1.includes(valueToSearch))
                invoices[i].style.display = "table-row";
            else
                invoices[i].style.display = "none";
        }
    }

    transferInvoices() {
        this.setState({transferring: true})
        
        fetch(  "/invoices/transfer/" + this.state.selectedUser.id_user, "GET", { "ids": [...this.state.invoiceSelection.flatMap(x => x._id)] }, () => {
            this.setState({ displayTransfer: false, selectedUser: null, transferring: false, invoiceSelection: [] }, () => {
                this.refreshInvoices();
            })
        },
        null, false, this.source.token)
    }

    sortInvoices(invoices) {
        if (!this.sortedColumn.name || this.sortedColumn.name === "") return invoices;

        for (let i = 0; i < invoices.length; i++) {
            let valueI = this.getColumnCompareValue(invoices[i], this.sortedColumn.name);

            for (let j = i + 1; j < invoices.length; j++) {
                let valueJ = this.getColumnCompareValue(invoices[j], this.sortedColumn.name);

                if ((valueJ < valueI && this.sortedColumn.sortAsc) || (valueJ > valueI && !this.sortedColumn.sortAsc)) {
                    let tmp = invoices[i];
                    invoices[i] = invoices[j];
                    invoices[j] = tmp;
                    valueI = valueJ;
                }
            }
        }
        return invoices;
    }

    sortDisplayedInvoices(column) {
        let invoices = this.state.allInvoices;

        if (this.sortedColumn.name === column) {
            this.sortedColumn.sortAsc = !this.sortedColumn.sortAsc;
        }
        else {
            this.sortedColumn.name = column;
            this.sortedColumn.sortAsc = true;
        }

        this.setState({
            invoices: this.filterSortInvoices(invoices)
        });
    }

    fetchInvoiceStatusCounts(){
        fetch(  `/invoices/statuses_count`, "GET", {}, response => {
            let status_counts = response.data.status_counts;
            this.props.data.status_counts = status_counts;
        });
    }

    refreshInvoices() {
        if (this.refreshId != null) {
            clearTimeout(this.refreshId);
            this.refreshId = null;
        }

        if (this.state.currentInvoice === null) {
            this.fetchInvoiceStatusCounts()
            this.currentStatus = this.props.data.selectedStatus;
            let searchData = "?";

            if (this.state.validatedSearchStr.trim().length > 0) {
                searchData += "str=" + encodeURIComponent(this.state.validatedSearchStr) + "&";
            }

            if (this.state.validatedSearchDateMin.trim().length > 0) {
                searchData += "date-min=" + encodeURIComponent(this.state.validatedSearchDateMin) + "&";
            }

            if (this.state.validatedSearchDateMax.trim().length > 0) {
                searchData += "date-max=" + encodeURIComponent(this.state.validatedSearchDateMax) + "&";
            }

            if (this.state.validatedSearchCreatedDateMin.trim().length > 0) {
                searchData += "created-date-min=" + encodeURIComponent(this.state.validatedSearchCreatedDateMin) + "&";
            }

            if (this.state.validatedSearchCreatedDateMax.trim().length > 0) {
                searchData += "created-date-max=" + encodeURIComponent(this.state.validatedSearchCreatedDateMax) + "&";
            }

            if (this.state.validatedSearchUser != null && this.state.validatedSearchUser.username != null && this.state.validatedSearchUser.username.trim().length > 0) {
                searchData += "username=" + encodeURIComponent(this.state.validatedSearchUser.username) + "&";
            }

            searchData += "page=" + encodeURIComponent(this.state.pageNumber) + "&";

            fetch(  "/invoices/list/" + this.currentStatus + searchData, "GET", {},
                response => {
                    if (!this._isMounted) return;
                    let allInvoices = response.data.invoices.sort(function (a, b) { return (a.created_at < b.created_at ? 1 : -1); });
                    this.duplicated_key = response.data.duplicated_key;
                    let invoices = this.filterSortInvoices(allInvoices);

                    this.setState({
                        invoices: invoices,
                        allInvoices: allInvoices,
                        pageCount: Math.floor(response.data.total / 100) + 1
                    }, () => {
                        if (!this._isMounted) return;
                        fetch(  "/invoices/stats", "GET", {},
                            response => {
                                if (!this._isMounted) return;
                                this.setState({
                                    total: response.data.total,
                                    processingTotal: response.data.process_total,
                                    monthlyTotals: response.data.monthly_totals
                                }, () => {
                                    if (!this._isMounted) return;
                                    this.refreshId = setTimeout(() => {
                                        this.refreshInvoices();
                                    }, response.data.process_total === 0 ? 10000 : 2000)
                                })
                            },
                            null, false, this.source.token)
                    })
                },
                null, false, this.source.token)
        }
       else {
            this.refreshId = setTimeout(() => {
                this.refreshInvoices();
            }, 10000)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.openInvoiceFromQueryParam();
        }

        if (this.props.data.vacation_mode !== prevProps.data.vacation_mode) {
            const nextVacationMode = this.normalizeVacationMode(this.props.data.vacation_mode);
            const currentVacationMode = this.normalizeVacationMode(this.state.currentUserVacationMode);

            if (JSON.stringify(nextVacationMode) !== JSON.stringify(currentVacationMode)) {
                this.setState((prevState) => ({
                    currentUserVacationMode: nextVacationMode,
                    vacationModeForm: prevState.showVacationModePrompt
                        ? prevState.vacationModeForm
                        : nextVacationMode,
                }));
            }
        }
        
        if(this.props.data.config?.invoice_exporter?.export_format){
            this.exportFormat = this.props.data.config.invoice_exporter.export_format
        }

        const { origin_role, role } = this.props.data;
        
        if (origin_role) {
            this.availableRoles = this.roleMapping[origin_role] || [];

            const extraRoles = (this.state.all_roles || []).filter(
                r => !this.roleMapping["SuperAdmin"].includes(r)
            );
            if(this.availableRoles.length !== 0) {
                this.availableRoles = [...this.availableRoles, ...extraRoles].filter(r => r !== role);
            }        }

        if (this.currentStatus !== this.props.data.selectedStatus) {
            this.currentStatus = this.props.data.selectedStatus;

            this.setState({
                invoices: [],
                invoiceSelection: [],
                searchStr: "",
                validatedSearchStr: ""
            }, () => {
                this.refreshInvoices(this.props.data.selectedStatus);
            });
        }

    }
    
    refreshClients() {
        fetch(  "/clients/", "GET", {}, response => {
            if (!this._isMounted) return;
            let clients = response.data.clients;
            this.setState({
                clients: [...clients]
            })
            })
    }

    fetchClientRoles(){
        fetch(  `/roles/names/`, "GET", {}, response => {
            if (!this._isMounted) return;
            const role_names = Array.isArray(response?.data) ? response.data : [];
            this.setState({all_roles: role_names});
        });
    }
    componentDidMount() {
        this._isMounted = true;
        this.fetchClientRoles();
        this.currentStatus = this.props.data.selectedStatus;
        this.refreshInvoices();
        this.openInvoiceFromQueryParam();
        this.refreshClients();

        fetch(  "/client/usersDetail", "GET", {},
            response => {
                if (!this._isMounted) return;
                this.setState({
                    users: response.data
                }, () => this.syncCurrentUserVacationMode(response.data))
            },
            null, false, this.source.token)

        fetch("/c_card/", "GET", {}, response => {
            if (!this._isMounted) return;
            this.setState({
                userHasCreditCards: response?.data?.meta?.totalRowCount > 0,
                creditCards: response?.data?.c_cards || []
            })
        }, null, false, this.source.token)
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.refreshId != null) {
            clearTimeout(this.refreshId);
        }
        if (this.matchUncategorizedInterval) {
            clearInterval(this.matchUncategorizedInterval);
            this.matchUncategorizedInterval = null;
        }
        this.source.cancel('dashboad unmounted');
    }

    clearInvoiceIdQueryParam() {
        const params = new URLSearchParams(this.props.location.search);
        if (!params.get("invoice_id")) {
            return;
        }

        params.delete("invoice_id");
        const search = params.toString();
        this.props.navigate(
            {
                pathname: this.props.location.pathname,
                search: search ? `?${search}` : "",
            },
            { replace: true }
        );
    }

    openInvoiceFromQueryParam() {
        const params = new URLSearchParams(this.props.location.search);
        const invoiceId = params.get("invoice_id");

        if (!invoiceId || this.state.currentInvoice === invoiceId) {
            return;
        }

        fetch(`/invoices/${invoiceId}`, "GET", {}, () => {
            if (!this._isMounted) return;
            this.setState({ currentInvoice: invoiceId }, () => {
                this.clearInvoiceIdQueryParam();
            });
        }, () => {
            if (!this._isMounted) return;
            this.clearInvoiceIdQueryParam();
        }, false, this.source.token);
    }

    selectInvoice(invoice) {
        if (!canOpenInvoiceEditorFromDashboard(invoice)) return;

        this.setState({
            currentInvoice: invoice._id
        });
    }

    /**
     * This method export the selected invoices in the selected format.
     * TODO : We should not do a querySelectorAll everytime we click to export invoices.
     * @param {str} format 
     */
    exportSelected(format) {
        finalizeSelectedInvoices(this, format);
    }

    closeInvoicePrompt(mustRefresh) {
        this.setState({
            currentInvoice: null,
            invoices: mustRefresh ? [] : this.state.invoices,
        }, () => {
            if (mustRefresh) {
                this.refreshInvoices()
            }
        })
    }

    checkSearch(e) {
        if (e.key === "Enter") {
            if (this.state.searchStr.trim().length > 0) {
                this.currentStatus = "All";
                DataStore.setSelectedStatus(this.props.data, "All");
            }

            this.setState({
                showCompletedInvoices: true,
                validatedSearchStr: this.state.searchStr
            }, () => {
                this.refreshInvoices();
            })
        }
    }

    containNonValidatedInvoice = () => {
        return this.state.invoiceSelection.find(x => x.status !== 'Validated') !== undefined;
    }

    canDeleteSelectedInvoices = () => {
        // User can delete if:
        // 1. All selected invoices belong to the user, OR
        // 2. User is Admin or Manager, OR
        // 3. User has the canDeleteInvoice permission
        if (Utils.userHasRole(this.props.data, ["Admin", "Manager"])) {
            return true;
        }

        if (AccessControl.hasActionAccess(this.props.data, "canDeleteInvoice")) {
            return true;
        }

        return Utils.allInvoicesBelongToUser(this.props.data, this.state.invoiceSelection);
    }

    processAction() {
        const invoices = this.state.invoiceSelection
        if (this.state.actionType === "delete") {
            this.setState({ deleting: true, actionType: null });
            let count = invoices.length;
            invoices.forEach(inv => {
                    fetch(  "/invoices/" + inv._id, "DELETE", {},
                        response => {
                            count--;

                            if (count === 0) {
                                this.setState({ deleting: false, invoiceSelection: [] }, () => this.refreshInvoices());
                            }
                        },
                        response => {
                            count--;

                            if (count === 0) {
                                this.setState({ deleting: false, invoiceSelection: [] }, () => this.refreshInvoices());
                            }
                        },
                        false, this.source.token
                    )
            });
        }
    }

    promptConnectAs() {
        this.setState({
            showConnectAsPrompt: true
        })
    }

    normalizeVacationMode(vacationMode = null) {
        return {
            enabled: Boolean(vacationMode?.enabled),
            start_date: vacationMode?.start_date ?? "",
            end_date: vacationMode?.end_date ?? "",
            delegate_approver: vacationMode?.delegate_approver ?? null,
        };
    }

    isVacationModeActive(vacationMode = this.state.currentUserVacationMode) {
        if (!vacationMode?.enabled || !vacationMode?.start_date || !vacationMode?.end_date) {
            return false;
        }

        const today = new Date().toISOString().slice(0, 10);
        return vacationMode.start_date <= today && today <= vacationMode.end_date;
    }

    getVacationDelegateOptions() {
        return (this.state.users ?? [])
            .filter((user) =>
                user?.id_user !== this.props.data.id_user &&
                user?.active !== false &&
                ["Approver", "Admin"].includes(user?.role)
            )
            .map((user) => ({
                value: user.id_user,
                label: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
                raw: {
                    id_user: user.id_user,
                    username: user.username,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    email: user.email,
                    role: user.role,
                }
            }));
    }

    syncCurrentUserVacationMode(users = this.state.users ?? []) {
        const currentUser = users.find((user) => user?.id_user === this.props.data.id_user);
        const currentUserVacationMode = this.normalizeVacationMode(currentUser?.vacation_mode);
        this.setState({
            currentUserVacationMode,
            vacationModeForm: currentUserVacationMode,
        });
    }

    openVacationModePrompt() {
        this.setState({
            showVacationModePrompt: true,
            vacationModeForm: this.normalizeVacationMode(this.state.currentUserVacationMode),
        });
    }

    saveVacationMode() {
        const { vacationModeForm } = this.state;
        const invalidRange =
            vacationModeForm.enabled &&
            vacationModeForm.start_date &&
            vacationModeForm.end_date &&
            vacationModeForm.end_date < vacationModeForm.start_date;

        if (
            invalidRange ||
            (
                vacationModeForm.enabled &&
                (!vacationModeForm.start_date || !vacationModeForm.end_date || !vacationModeForm.delegate_approver)
            )
        ) {
            return;
        }

        const formData = new FormData();
        formData.append("vacation_mode", JSON.stringify({
            enabled: vacationModeForm.enabled,
            start_date: vacationModeForm.start_date,
            end_date: vacationModeForm.end_date,
            delegate_approver: vacationModeForm.delegate_approver,
        }));

        this.setState({ savingVacationMode: true });
        fetch(`/users/me/vacation-mode`, "PUT", formData, () => {
            fetch("/client/usersDetail", "GET", {}, (response) => {
                if (!this._isMounted) return;
                this.setState({
                    users: response.data,
                    showVacationModePrompt: false,
                    savingVacationMode: false,
                }, () => this.syncCurrentUserVacationMode(response.data));
            }, () => {
                this.setState({
                    savingVacationMode: false,
                    errorMessage: this.props.data.t.read("internal_saving_error"),
                });
            }, false, this.source.token);
        }, () => {
            this.setState({
                savingVacationMode: false,
                errorMessage: this.props.data.t.read("internal_saving_error"),
            });
        }, false, this.source.token);
    }

    confirmConnectAs() {
        let formData = new FormData();
        formData.append("role", this.state.connectAs);

        fetch(  "/auth/connect-as-role", "POST", formData,
            response => {
                // Update user data immediately with the new role if full data is provided
                if (response.data && response.data.token && response.data.role) {
                    DataStore.updateUserData(this.props.data, response.data, response.data.token);
                    this.setState({
                        showConnectAsPrompt: false
                    });
                } else {
                    // If response only has token, store it and reload to trigger refresh-token call
                    if (response.data && response.data.token) {
                        window.localStorage.setItem("jwt", response.data.token);
                    }
                    window.location.reload();
                }
            },
            response => {
                this.setState({
                    showConnectAsPrompt: false
                })
            },
            false, this.source.token
            )
    }

    confirmConnectClientAs() {
        let formData = new FormData();
        formData.append("id_client", this.state.connectAsClient?._id);

        fetch(  "/auth/connect-as-client", "POST", formData,
            response => {
                // Update user data immediately with the new client if full data is provided
                if (response.data && response.data.token && response.data.id_client) {
                    DataStore.updateUserData(this.props.data, response.data, response.data.token);
                    this.setState({
                        showChangeClientPrompt: false
                    });
                } else {
                    // If response only has token, store it and reload to trigger refresh-token call
                    if (response.data && response.data.token) {
                        window.localStorage.setItem("jwt", response.data.token);
                    }
                    window.location.reload();
                }
            },
            response => {
                this.setState({
                    showChangeClientPrompt: false
                })
            },
            false, this.source.token
            )
    }

    toggleAdvancedSearch() {
        this.setState({
            showAdvancedSearch: !this.state.showAdvancedSearch
        })
    }

    processAdvancedSearch() {
        this.setState({
            showAdvancedSearch: false,
            validatedSearchUser: this.state.searchUser,
            validatedSearchDateMin: this.state.searchDateMin,
            validatedSearchDateMax: this.state.searchDateMax,
            validatedSearchCreatedDateMin: this.state.searchCreatedDateMin,
            validatedSearchCreatedDateMax: this.state.searchCreatedDateMax,
        }, () => {
            this.refreshInvoices();
        })
    }

    resetAdvancedSearch() {
        this.setState({
            searchUser: null,
            searchDateMin: "",
            searchDateMax: "",
            searchCreatedDateMin: "",
            searchCreatedDateMax: "",
            validatedSearchUser: null,
            validatedSearchDateMin: "",
            validatedSearchDateMax: "",
            validatedSearchCreatedDateMin: "",
            validatedSearchCreatedDateMax: "",
        }, () => {
            this.refreshInvoices();
        })
    }

    showTableConfig() {
        let columnsToDisplayTmp = [...this.state.columnsToDisplay]
        this.setState({
            columnsToDisplayTmp: columnsToDisplayTmp,
            showTableConfig: true
        });
    }

    updateColumnToDisplay(name) {
        let idx = this.state.columnsToDisplayTmp.indexOf(name);

        if (idx === -1) {
            let cols = this.state.columnsToDisplayTmp;
            cols.push(name);

            this.setState({
                columnsToDisplayTmp: cols
            })
        }
        else {
            let cols = this.state.columnsToDisplayTmp;
            cols.splice(idx, 1);

            this.setState({
                columnsToDisplayTmp: cols
            })
        }
    }

    handlePageChange(page) {
        if (page > this.state.pageCount || page < 1) {
            return;
        }
        this.setState({
            pageNumber: page,
        }, () => {
            this.refreshInvoices();
        });
    }

    saveColumnsToDisplay() {
        localStorage["colsToDisplay"] = JSON.stringify(this.state.columnsToDisplayTmp);

        this.setState({
            columnsToDisplay: this.state.columnsToDisplayTmp,
            showTableConfig: false
        })
    }

    getIndexColumn(col) {
        return this.state.columnsToDisplay.indexOf(col.name);
    }

    updateFilterValueCheck(value) {
        let column = this.state.displayFilterBy;
        let idxColumn = this.state.columnsToDisplay.indexOf(column.name);

        let idx = this.state.listFilters[idxColumn].indexOf(value);

        if (idx === -1) {
            let cols = this.state.listFilters;
            cols[idxColumn].push(value);

            this.setState({
                listFilters: cols
            })
        }
        else {
            let cols = this.state.listFilters;
            cols[idxColumn].splice(idx, 1);

            this.setState({
                listFilters: cols
            })
        }
    }

    resetFilters() {
        this.setState({
            listFilters: [],
            filterBys: []
        }, () => {
            this.refreshInvoices();
        })
    }

    generateChoiceList(col) {
        let invoices = this.state.allInvoices;
        let set = new Set();

        invoices.forEach(invoice => {
            let el1 = this.getColumnValue(invoice, col);
            set.add(el1)
        });
        
        return set;
    }

    displayFilterMenu(col) {
        let choices = Array.from(this.generateChoiceList(col));
        let filters = this.state.listFilters;

        if (!filters[this.getIndexColumn(col)]) {
            filters[this.getIndexColumn(col)] = [];
        }

        this.setState({
            displayFilterBy: col,
            choiceListFilter: choices,
            allChoicesListFilter: choices,
            listFilters: filters
        });
    }

    hasDuplicates(invoice){
        if(!this.duplicated_key)
            return false;

        const supplierColumn      = this.availableColumns.find(col => col.displayName === 'supplier_name');
        const invoiceNumberColumn = this.availableColumns.find(col => col.displayName === 'invoice_number');

        return this.duplicated_key.includes(this.getColumnValue(invoice, invoiceNumberColumn) + this.getColumnValue(invoice, supplierColumn));
    }

    // Finalization errors come only from finalization_errors; last error for tooltip = last element of that array. json.FinalizationError no longer used (XPEN-1990).
    hasFinalizationError(invoice){
        if(invoice.status !== "Validated")
            return false;
        return getFinalizationErrors(invoice).length > 0;
    }

    getFinalizationError(invoice){
        return getLastFinalizationError(invoice);
    }

    filterSortInvoices(invoices) {
        let filters = this.state.filterBys;
        let invoicesToDisplay = Array.from(invoices);

        invoices.forEach(invoice => {
            let toKeep = true;

            filters.forEach(item => {
                if (!item || !toKeep) return;

                let col = item[0];
                let filter = item[1];

                let element = this.getColumnValue(invoice, col);

                toKeep = filter.indexOf(element) !== -1;
            })

            if (!toKeep) {
                invoicesToDisplay.splice(invoicesToDisplay.indexOf(invoice), 1);
            }
        })

        return this.sortInvoices(invoicesToDisplay);
    }

    filterMenuDone() {
        let column = this.state.displayFilterBy;
        let idx = this.state.columnsToDisplay.indexOf(column.name);
        let filters = this.state.listFilters[idx];
        let arr = this.state.filterBys;

        if (filters.length !== 0) {
            let index = this.state.columnsToDisplay.indexOf(column.name);
            arr[index] = [column, filters];
        }

        this.setState({
            displayFilterBy: "",
            filterBys: arr
        }, () => {
            this.refreshInvoices();
        })
    }

    searchChoicesFilter(e) {
        let choices = this.state.allChoicesListFilter;
        let result = [];
        let val = e.target.value.toLowerCase();

        choices.forEach(choice => {
            if (choice.toLowerCase().includes(val))
                result.push(choice);
        })

        this.setState({
            choiceListFilter: result
        })
    }

    cancelFilterMenu() {
        let filters = this.state.listFilters;
        let idx = this.state.columnsToDisplay.indexOf(this.state.displayFilterBy.name);
        filters.splice(idx, 1);

        this.setState({
            displayFilterBy: "",
            listFilters: filters
        })
    }

    getColumnValue(invoice, column) {
        let value = "";

        try {
            value = column.evaluate(invoice);
        }
        catch (e) {
        }

        return value;
    }

    getColumnCompareValue(invoice, columnName) {
        let result = invoice;
        let column = this.availableColumns.find(e => e.displayName === columnName).name;
        columnName = column.replace("[", ".").replace("]", "");
        let parameters = columnName.split(".");

        for (let i = 0; i < parameters.length; i++) {

            if(result === undefined || result === null || result.length === 0)
                break;

            if(typeof parameters[i] === "number")
                parameters[i] = Number(parameters[i]);

            result = result[parameters[i]];
        }

        if (!result) result = "";
        return result;
    }

    onKeyDownFunction(e) {
        if (e.key === "Escape") {
            this.setState({
                currentInvoice: null
            });
        }
    }

    dragOver(e){
        e.stopPropagation();
        e.preventDefault();
    }

    dragStart(e, column){
        this.columnDragInitial = column;
    }

    drop(e, column) {
        e.stopPropagation();
        e.preventDefault();
        const columns = [...this.state.columnsToDisplay];
        this.columnDragFinal = column;
        const indexInitial = columns.findIndex(col => col === this.columnDragInitial);
        const indexFinal   = columns.findIndex(col => col === this.columnDragFinal);

        let i;
        if(indexInitial > indexFinal){
            for(i = indexFinal; i < indexInitial; i++  ){
                columns[i+1] = this.state.columnsToDisplay[i];
            }
        }

        if( indexFinal > indexInitial){
            for(i = indexInitial; i < indexFinal; i++ ){
                columns[i] = this.state.columnsToDisplay[i+1];
            }
            columns[indexFinal] = this.columnDragInitial;
        }

        columns[indexFinal] = this.columnDragInitial;

        this.setState({columnsToDisplay: [...columns]});
        localStorage["colsToDisplay"] = JSON.stringify(columns);
        this.draggable = false;
    }

    isAllInvoicesSelected = () => {
        return this.state.invoiceSelection.length > 1 && this.state.invoiceSelection.length === this.state.invoices.length;
    }

    toggleAllInvoicesSelected = () => {
        this.state.invoiceSelection.length === this.state.invoices.length ? this.setState({invoiceSelection: []}) : this.setState( {invoiceSelection: [...this.state.invoices]});
    }

    isInvoiceSelected = (inv) => {
        return this.state.invoiceSelection.find(x => x._id === inv._id) !== undefined;
    }

    shoulDisableActions = () => !Utils.userHasRole(this.props.data, ["Admin", "Manager"]) || this.state.transferring || this.state.exporting.size || !this.state.invoiceSelection.length || this.state.deleting;

    shouldDisableFinalize = () => !AccessControl.hasActionAccess(this.props.data, "canFinalizeInvoices") || this.state.transferring || this.state.exporting.size || !this.state.invoiceSelection.length || this.state.deleting;

    shouldDisableDelete = () => {
        // Operational checks: transferring, exporting, deleting, or no selection
        if (this.state.transferring || this.state.exporting.size || this.state.deleting || !this.state.invoiceSelection.length) {
            return true;
        }
        
        // If invoices are NOT deletable, only SuperAdmin and Admin can delete them
        if (!Utils.allInvoicesDeletable(this.state.invoiceSelection)) {
            return !Utils.userHasRole(this.props.data, ["SuperAdmin", "Admin", "Manager"]);
        }
        
        // If invoices ARE deletable, check if user has permission/ownership
        if (!this.canDeleteSelectedInvoices()) {
            return true;
        }
        
        return false;
    }


    renderPagination() {
        let toRender = [];
        for (let i = 0; i < this.state.pageCount; i++) {
            if ((i === 0 || i + 1 === this.state.pageCount) || (i + 1 >= this.state.pageNumber - 3 && i + 1 <= this.state.pageNumber + 3)) {
                if ((i === 0 || i + 1 === this.state.pageCount) || (i + 1 >= this.state.pageNumber - 2 && i + 1 <= this.state.pageNumber + 2)) {
                    let classes = "page-item";
                    if (i + 1 === this.state.pageNumber)
                        classes += " active";
                    toRender.push(<li key={"page-"+i} className={classes}><p className="page-link" onClick={() => this.handlePageChange(i + 1)}>{i + 1}</p></li>);
                } else {
                    toRender.push(<li key={"page-"+i} className="page-item disabled"><p className="page-link">...</p></li>);
                }
            }
        }
        return toRender.map((e) => {
            return e;
        });
    }

    getPaymentColumnInfoCard(invoice, column) {
        function getCCardMaskForInvoice(creditCards, invoice, t) {
            const card = creditCards?.find(p => p.supplier?._id === (invoice?.json?.ListSupplier && invoice?.json?.ListSupplier.length > 0 ? invoice?.json?.ListSupplier[0]?.Index : undefined));
            if(card){
                return `${t.read("invoice.paid_by_cc")} ${card.card_masked_number}`;
            }
            return t.read("invoice.payment_not_found");
        }
        if(invoice.type === "p-card") {

            return (
                <HoverInfoCard
                    info={this.state.creditCards && getCCardMaskForInvoice(this.state.creditCards, invoice, this.props.data.t)}
                    additionalInfo={
                        <div className={"d-flex flex-column"}>
                            <span className={""}>{`${this.props.data.t.read("invoice.status_txt")}: ${invoice.status + ""}`}</span>
                            {invoice.payment?.CheckDate  && <span className={""}>{`${this.props.data.t.read("invoice.payment_date")}: ${Intl.DateTimeFormat(`${this.props.data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(invoice.payment?.CheckDate))}`}</span>}
                            <span className={""}>{`${this.props.data.t.read("invoice.amount_paid")}: $${invoice.json?.TotalWithTax || ""}`}</span>
                        </div>
                    }
                />
            );
        }
        else {
            return (
                <HoverInfoCard
                    info={this.getColumnValue(invoice, column) || (this.state.creditCards && getCCardMaskForInvoice(this.state.creditCards, invoice, this.props.data.t))}
                    additionalInfo={
                        <div className={"d-flex flex-column"}>
                            <span className={""}>{`${this.props.data.t.read("invoice.status_txt")}: ${this.getColumnValue(invoice, column) + ""}`}</span>
                            <span className={""}>{`${this.props.data.t.read("invoice.cheque_number")}: ${invoice.payment?.CheckNumber}`}</span>
                            <span className={""}>{`${this.props.data.t.read("invoice.payment_date")}: ${invoice.payment?.CheckDate ? Intl.DateTimeFormat(`${this.props.data.t.lang}-US`,{year: 'numeric',  month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,  }).format(new Date(invoice.payment?.CheckDate)) : "-"}`}</span>
                            <span className={""}>{`${this.props.data.t.read("invoice.amount_paid")}: $${invoice.payment?.PaymentAmount}`}</span>
                        </div>
                    }
                />
            );
        }

    }

    render() {
        

        return <div tabIndex={-10} onKeyDown={e => this.onKeyDownFunction(e)} style={{ outline: "none" }}>
            {
                this.state.errorMessage != null ?
                <Modal title="Attention" okText={"OK"} okAction={() => this.setState({ errorMessage: null })}>
                <p className='text-danger'>{this.state.errorMessage}</p>
                </Modal>
                : 
                null
            }
            {
                this.state.successMessage != null ?
                <Modal title="Success" okText={"OK"} okAction={() => this.setState({ successMessage: null })}>
                <p className='alert-success'>{this.state.successMessage}</p>
                </Modal>
                : 
                null
            }
            {
                this.state.actionType != null ?
                    <Modal title={this.props.data.t.read("confirm")} cancelAction={() => this.setState({ actionType: null })} okAction={() => this.processAction()} okText={this.props.data.t.read(this.state.actionType)} cancelText={this.props.data.t.read("no")}>
                        {this.props.data.t.read("modal_" + this.state.actionType)}
                    </Modal>
                    :
                    null
            }
            {
                this.state.showTableConfig ?
                    <Modal title={this.props.data.t.read("table_config_title")} cancelAction={() => this.setState({ showTableConfig: false })} okAction={() => this.saveColumnsToDisplay()} okText={this.props.data.t.read("save")} cancelText={this.props.data.t.read("cancel")}>
                        {this.props.data.t.read("table_config_content")}
                        <div className="mt-4">
                            {
                                this.availableColumns
                                .filter(col => col.name !== "approver" || Utils.userHasPageAccess(this.props.data, "approval"))
                                .map(col => {
                                    return <div key={col.name}>
                                        <label>
                                            <input type="checkbox" onChange={() => this.updateColumnToDisplay(col.name)} checked={this.state.columnsToDisplayTmp.indexOf(col.name) !== -1 ? true : false} /> {this.props.data.t.read("invoice." + col.displayName)}
                                        </label>
                                    </div>
                                })
                            }
                        </div>
                    </Modal>
                    :
                    null
            }
            {
                this.state.displayFilterBy !== "" ?
                    <Modal title={this.props.data.t.read("filter_by") + " " + this.state.displayFilterBy.displayName} cancelAction={() => this.cancelFilterMenu()} okAction={() => this.filterMenuDone()} okText={this.props.data.t.read("filter")} cancelText={this.props.data.t.read("cancel")}>
                        <div className='mt-2' style={{ textAlign: "center" }}>
                            <input onChange={v => this.searchChoicesFilter(v)}></input>
                        </div>
                        <hr></hr>
                        <div className="mt-4">
                            {
                                this.state.choiceListFilter.map(val => {
                                    return <div key={"choiceFilter" + val}>
                                        <label>
                                            <input type="checkbox" onChange={() => this.updateFilterValueCheck(val)} checked={this.state.listFilters[this.getIndexColumn(this.state.displayFilterBy)].indexOf(val) !== -1 ? true : false} /> <span className={"ml-2"}>{val}</span>
                                        </label>
                                    </div>
                                })
                            }
                        </div>
                    </Modal>
                    :
                    null
            }
            {
                this.state.showConnectAsPrompt ?
                    <Modal title={this.props.data.t.read("connect_as")} cancelAction={() => this.setState({ showConnectAsPrompt: false })} okAction={() => this.confirmConnectAs()} okText={this.props.data.t.read("connect")} cancelText={this.props.data.t.read("cancel")}>
                        {
                            this.availableRoles.filter(role => !(role==="Approver" && this.props.data.config.roles.indexOf("Approver") === -1) ).map(r => {
                                return <label className="d-block" key={"modal-role-" + r}>
                                    <input type="radio" name="connect_as" checked={this.state.connectAs === r} onChange={() => this.setState({ connectAs: r })} />
                                    {" " + (this.props.data.t.read("role_" + r.toLowerCase()) || r) + " "}
                                </label>
                            })
                        }
                    </Modal>
                    :
                    null
            }
            {
                this.state.showChangeClientPrompt ?
                    <Modal title={this.props.data.t.read("connect_as")} cancelAction={() => this.setState({ showChangeClientPrompt: false })} okAction={() => this.confirmConnectClientAs()} okText={this.props.data.t.read("connect")} cancelText={this.props.data.t.read("cancel")}>
                        {
                            this.state.clients.map(c => {
                                return <label className="d-block" key={c._id}>
                                    <input type="radio" name="connect_as_client" checked={this.state.connectAsClient?._id === c._id} onChange={() => this.setState({ connectAsClient: c })} />
                                    {c.name}
                                </label>
                            })
                        }
                    </Modal>
                    :
                    null
            }
            {
                this.state.showVacationModePrompt ?
                    <Modal
                        overflow="visible"
                        invalid={
                            this.state.savingVacationMode ||
                            (
                                this.state.vacationModeForm.enabled &&
                                (
                                    !this.state.vacationModeForm.start_date ||
                                    !this.state.vacationModeForm.end_date ||
                                    !this.state.vacationModeForm.delegate_approver ||
                                    this.state.vacationModeForm.end_date < this.state.vacationModeForm.start_date
                                )
                            )
                        }
                        title={this.props.data.t.read("vacation_mode")}
                        cancelAction={() => this.setState({ showVacationModePrompt: false, savingVacationMode: false })}
                        okAction={() => this.saveVacationMode()}
                        okText={this.props.data.t.read("save")}
                        cancelText={this.props.data.t.read("cancel")}
                    >
                        <div className="form-group d-flex align-items-center">
                            <input
                                id="vacation-mode-enabled"
                                type="checkbox"
                                className="mr-2"
                                checked={this.state.vacationModeForm.enabled}
                                onChange={(event) => this.setState({
                                    vacationModeForm: {
                                        ...this.state.vacationModeForm,
                                        enabled: event.target.checked,
                                    }
                                })}
                            />
                            <label className="mb-0" htmlFor="vacation-mode-enabled">{this.props.data.t.read("vacation_mode_enabled")}</label>
                        </div>
                        <div className="form-group">
                            <label>{this.props.data.t.read("vacation_delegate")}</label>
                            <Select
                                classNamePrefix="select"
                                isClearable
                                isDisabled={!this.state.vacationModeForm.enabled}
                                options={this.getVacationDelegateOptions()}
                                value={this.getVacationDelegateOptions().find(
                                    (option) => option.raw.id_user === this.state.vacationModeForm.delegate_approver?.id_user
                                ) ?? null}
                                onChange={(option) => this.setState({
                                    vacationModeForm: {
                                        ...this.state.vacationModeForm,
                                        delegate_approver: option?.raw ?? null,
                                    }
                                })}
                            />
                        </div>
                        <div className="form-group">
                            <label>{this.props.data.t.read("vacation_start_date")}</label>
                            <input
                                type="date"
                                className="form-control"
                                disabled={!this.state.vacationModeForm.enabled}
                                value={this.state.vacationModeForm.start_date}
                                onChange={(event) => this.setState({
                                    vacationModeForm: {
                                        ...this.state.vacationModeForm,
                                        start_date: event.target.value,
                                    }
                                })}
                            />
                        </div>
                        <div className="form-group">
                            <label>{this.props.data.t.read("vacation_end_date")}</label>
                            <input
                                type="date"
                                className="form-control"
                                disabled={!this.state.vacationModeForm.enabled}
                                value={this.state.vacationModeForm.end_date}
                                onChange={(event) => this.setState({
                                    vacationModeForm: {
                                        ...this.state.vacationModeForm,
                                        end_date: event.target.value,
                                    }
                                })}
                            />
                        </div>
                    </Modal>
                    :
                    null
            }
            {
                this.state.displayTransfer ?
                    <Modal invalid={!this.state.selectedUser} overflow="visible" title={this.props.data.t.read("transfer_to")} cancelAction={() => this.setState({ displayTransfer: false })} okAction={() => this.transferInvoices()} okText={this.props.data.t.read("transfer_invoice")} cancelText={this.props.data.t.read("cancel")}>
                        <FormSelectUser options={this.state.users.sort((a,b) => a["first_name"] + a["last_name"] > b["first_name"] +b["last_name"] ? 1 :-1)} optionChanged={option => { this.setState({ selectedUser: option }) }} />
                    </Modal>
                    :
                    null
            }
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <div className="flex-start">
                        <input type="text" className="form-control search-field" placeholder={this.props.data.t.read("search_by")} value={this.state.searchStr} onChange={e => this.setState({ searchStr: e.target.value })} onKeyUp={e => this.checkSearch(e)} />
                        <div>
                            <button className="btn btn-sm btn-link btn-fade-over" onClick={() => this.toggleAdvancedSearch()}>
                                {this.props.data.t.read("advanced_search")} <FontAwesomeIcon className="text-primary" icon={faAngleDown} />
                            </button>
                        </div>
                        <div className="position-relative">
                            {
                                this.state.showAdvancedSearch ?
                                    <div className="advanced-search-section">
                                        {
                                            canUseDashboardUserFilter(this.props.data) ?
                                                <div className="search-line">
                                                    <div>{this.props.data.t.read("invoice.user")} :</div>
                                                    <div>
                                                        <FormSelectUser data={this.props.data} chosenOption={this.state.searchUser} options={this.state.users.sort((a,b) => a["first_name"] + a["last_name"] > b["first_name"] +b["last_name"] ? 1 :-1)} optionChanged={option => { this.setState({ searchUser: option }) }} />
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                        <div className="search-line">
                                            <div>{this.props.data.t.read("invoice.billing_date")} :</div>
                                            <div>
                                                <input type="date" className="form-control search-input-field" value={this.state.searchDateMin} onChange={e => this.setState({ searchDateMin: e.target.value })} />
                                            </div>
                                            <div>
                                                -
                                            </div>
                                            <div>
                                                <input type="date" className="form-control search-input-field" value={this.state.searchDateMax} onChange={e => this.setState({ searchDateMax: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="search-line">
                                            <div>{this.props.data.t.read("invoice.inserted_date")} :</div>
                                            <div>
                                                <input type="date" className="form-control search-input-field" value={this.state.searchCreatedDateMin} onChange={e => this.setState({ searchCreatedDateMin: e.target.value })} />
                                            </div>
                                            <div>
                                                -
                                            </div>
                                            <div>
                                                <input type="date" className="form-control search-input-field" value={this.state.searchCreatedDateMax} onChange={e => this.setState({ searchCreatedDateMax: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mt-3">
                                            <button className="btn btn-sm btn-link btn-fade-over" onClick={() => this.resetAdvancedSearch()}>
                                                {this.props.data.t.read("reset")}
                                            </button>
                                            <button className="btn btn-sm btn-primary" onClick={() => this.processAdvancedSearch()}>
                                                {this.props.data.t.read("search")}
                                            </button>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    <div className="flex-end">
                        <img src={iconSpeaker} alt="Notifications" className="faded mr-2" />
                        <img src={iconHelp} alt="Help" className="faded" />
                    </div>
                </div>
                <div className="d-flex justify-content-between mb-3">
                    <div className="flex-3">
                        <h4>
                            {`${this.props.data.t.read("greetings")} `}
                            <img width="20" height="20" alt="Hello!" src="data:image/png;base64,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" />,
                        </h4>
                        <h3 className="text-primary font-weight-bold mb-0">
                            {this.props.data.firstName} {this.props.data.lastName} 
                        </h3>
                        <h5 className="mb-4">
                            <div>
                                <span className='mr-4'>
                                {this.props.data.client_name}
                                {
                                 this.state.clients?.length > 1 &&    <button className="btn btn-sm btn-link btn-fade-over" onClick={() => this.setState({showChangeClientPrompt: true})}>
                                            <FontAwesomeIcon className="text-secondary font-large" icon={faAngleDown} />
                                    </button>
                                }
                                </span>
                                {this.props.data.role && (this.props.data.t.read("role_" + this.props.data.role.toLowerCase()) || this.props.data.role) + " "}
                                {
                                    this.availableRoles.length > 0 && <button className="btn btn-sm btn-link btn-fade-over" onClick={() => this.promptConnectAs()}>
                                                                            <FontAwesomeIcon className="text-secondary font-large" icon={faAngleDown} />
                                                                    </button>         
                                }
                            </div>
                            {["Approver", "Admin"].includes(this.props.data.role) && (
                                <div className="mt-2 d-flex align-items-center">
                                    <button className="btn btn-sm btn-outline-secondary" onClick={() => this.openVacationModePrompt()}>
                                        {this.props.data.t.read("vacation_mode")}
                                    </button>
                                    <span className="ml-3 text-muted">
                                        {this.isVacationModeActive()
                                            ? `${this.props.data.t.read("vacation_mode_active")} ${this.state.currentUserVacationMode?.end_date}`
                                            : this.props.data.t.read("vacation_mode_inactive")}
                                    </span>
                                </div>
                            )}
                        </h5>
                        <div>
                            <div className="d-flex">
                                { 
                                    (this.props.data.role !== "Approver" || this.props.data.config?.frontend_invoice?.approver_can_add_invoice) && 
                                    <>
                                        <Link to="/new" className="btn btn-primary btn-primary-shadow pb-2 pt-2">
                                            {this.props.data.t.read("add_new_invoice")}
                                        </Link>
                                        {
                                            AccessControl.canCreateCreditCardInvoice(this.props.data) && this.state.userHasCreditCards && <Link to="/new/credit-card" className="btn btn-secondary btn-secondary-shadow pb-2 pt-2 ml-3">
                                                {this.props.data.t.read("add_cc_invoice")}
                                            </Link>
                                        }
                                    </>
                                }
                                <div className="ml-3">
                                    {
                                        this.state.total !== "" ?
                                            <div>
                                                <div className="font-weight-bold font-large" style={{ lineHeight: "1.3rem" }}>
                                                    {this.state.total} {this.props.data.t.read("invoices")}
                                                </div>
                                                <div className="text-primary font-small" style={{ lineHeight: "1rem" }}>
                                                    {this.state.processingTotal} {this.props.data.t.read("processing")}
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="pt-4 mt-4 border-top">
                            {
                                this.props.data.selectedStatus === "All" && this.props.data.role !== "Approver"?
                                    <label className="font-small d-flex">
                                        <input type="checkbox" className="d-inline-block mr-3" checked={this.state.showCompletedInvoices} onChange={() => this.setState({ showCompletedInvoices: !this.state.showCompletedInvoices, invoiceSelection: [] })} />
                                        {this.props.data.t.read("show_completed_invoices")}
                                    </label>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    <div className="flex-5 ml-3 pt-3 pl-3 pr-0 d-flex flex-column">
                        <div className="d-flex flex-wrap gap-4 mb-2 align-items-center">
                            <p className="mb-0"><strong>Inv:</strong> <a color={"hsl(38, 100%, 48%)"} href="mailto:doc@xpens.ai">doc@xpens.ai</a></p>
                            <p className="mb-0 ml-4"><strong>Cc:</strong> <a href="mailto:scan@xpens.ai">scan@xpens.ai</a></p>
                            <p className="mb-0 ml-4"><strong>Exp:</strong> <a href="mailto:note@xpens.ai">note@xpens.ai</a></p>
                        </div>
                        <div style={{ height: "175px" }}>
                            <div className="bg-white" >
                                <div>
                                    <GraphLine dataset={this.state.monthlyTotals} id="monthly-totals" preventTriming={true} labels={[this.props.data.t.read('month.jan').toUpperCase(), this.props.data.t.read('month.feb').toUpperCase(), this.props.data.t.read('month.mar').toUpperCase(),
                                    this.props.data.t.read('month.apr').toUpperCase(), this.props.data.t.read('month.may').toUpperCase(), this.props.data.t.read('month.jun').toUpperCase(),
                                    this.props.data.t.read('month.jul').toUpperCase(), this.props.data.t.read('month.aug').toUpperCase(), this.props.data.t.read('month.sep').toUpperCase(),
                                    this.props.data.t.read('month.oct').toUpperCase(), this.props.data.t.read('month.nov').toUpperCase(), this.props.data.t.read('month.dec').toUpperCase()]} />
                                </div>
                            </div>
                        </div>
                        <div className="text-right mt-auto pt-2">
                            <button className="btn btn-secondary btn-sm mr-4" onClick={() => this.resetFilters()} >{this.props.data.t.read("reset_filters")}</button>
                            <button className="btn btn-primary btn-sm mr-2" disabled = {this.containNonValidatedInvoice() || this.shouldDisableFinalize()} onClick={() => this.exportSelected(this.exportFormat)} >{this.props.data.t.read("finalize")} {this.state.exporting.has(this.exportFormat) && <FontAwesomeIcon className="ml-2 text-dark infinite-rotate" icon={faSync} />}</button>
                            <button className="btn btn-secondary btn-sm mr-2" disabled={this.shoulDisableActions()} onClick={() => this.setState({displayTransfer: true})} >{this.props.data.t.read("transfer_invoice")} {this.state.transferring && <FontAwesomeIcon className="ml-2 text-dark infinite-rotate" icon={faSync} />}</button>
                            <button className="btn btn-secondary btn-sm"  disabled={this.shouldDisableDelete()} onClick={() => this.setState({actionType: 'delete'})} >{this.props.data.t.read("delete")} {this.state.deleting && <FontAwesomeIcon className="ml-2 text-dark infinite-rotate" icon={faSync} />}</button>
                        </div>
                        
                    </div>
                </div>

                <div className={"invoices status-" + this.props.data.selectedStatus}>
                    <table className="table bg-white table-hover">
                        <thead>
                            <tr>
                                <th>
                                    <Checkbox disabled={!this.state.invoices?.length} isChecked={this.isAllInvoicesSelected()} onChange={this.toggleAllInvoicesSelected} />
                                </th>
                                {
                                    this.state.columnsToDisplay
                                    .filter(col => col !== "approver" || Utils.userHasPageAccess(this.props.data, "approval"))
                                    .map(col => {
                                        let column = this.availableColumns.find(c => c.name === col);
                                        let filters = this.state.listFilters[this.getIndexColumn(column)];

                                        return <th key={"header-" + column.displayName}>
                                                <div draggable="true" onDrop={e => this.drop(e, col)}  onDragStart={e => this.dragStart(e, col)} onDragOver={e => this.dragOver(e)}>
        
                                                    <span style={{ userSelect: "none" }} onClick={() => this.sortDisplayedInvoices(column.displayName)}>
                                                        {this.props.data.t.read("invoice." + column.displayName)}
                                                    </span>
                    
                                                    {
                                                        !this.colsToNotFilter.includes(column.displayName) ?
                                                            <FontAwesomeIcon className={"text-secondary ml-2 " + ((filters && filters.length > 0) ? "blue" : "")} icon={faFilter} onClick={() => this.displayFilterMenu(column)} style={{ cursor: "pointer" }} />
                                                            :
                                                            null
                                                    }
                                                </div>
                                        </th>
                                    })
                                }
                                <th style={{ width: "30px", textAlign: "center" }}>
                                    <FontAwesomeIcon className="text-secondary" icon={faCog} onClick={() => this.showTableConfig()} style={{ cursor: "pointer" }} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.invoices.map(invoice => {
                                    if (!invoice.hasOwnProperty("is_deleted")) {
                                        invoice.is_deleted = false;
                                    }

                                    if ((this.props.data.selectedStatus === "Deleted" && invoice.is_deleted) ||
                                        (!invoice.is_deleted && ((this.state.showCompletedInvoices || this.props.data.role === "Approver") || this.props.data.selectedStatus !== "All" || ["Pending", "Processing", "Need_Attention", "Invalid"].includes(invoice.status)))) {
                                        
                                        const titleParts = [];
                                        if (this.hasDuplicates(invoice)) {
                                            titleParts.push(this.props.data.t.read("invoice.hasDuplicates"));
                                        }
                                        if (this.hasFinalizationError(invoice)) {
                                            titleParts.push(this.getFinalizationError(invoice));
                                        }
                                        const titleText = titleParts.length > 0 ? titleParts.join(" | ") : null;
                                        const canOpenInvoice = canOpenInvoiceEditorFromDashboard(invoice);
                                        const openInvoice = canOpenInvoice ? () => this.selectInvoice(invoice) : undefined;
                                        
                                        return (
                                            <tr key={invoice._id}
                                                title={titleText}
                                                className={`${this.hasDuplicates(invoice) ? "invoice-duplicates" : ""} ${invoice.status?.toLowerCase() === "finalizing" ? "invoice-finalizing " : ""} ${this.hasFinalizationError(invoice) ? "invoice-finalization-error" : ""}`.trim() || null}>
                                                <td onClick={e => e.stopPropagation()}>
                                                    <Checkbox isChecked={this.isInvoiceSelected(invoice)} onChange={e => this.isInvoiceSelected(invoice) ? this.setState({ invoiceSelection: [...this.state.invoiceSelection.filter(x => x._id != invoice._id)]}) : this.setState({invoiceSelection: [...this.state.invoiceSelection, invoice]})} />
                                                </td>
                                                {
                                                    this.state.columnsToDisplay
                                                    .filter(col => col !== "approver" || Utils.userHasPageAccess(this.props.data, "approval"))
                                                    .map(col => {
                                                        let column = null;

                                                        this.availableColumns.forEach(c => {
                                                            if (c.name === col) {
                                                                column = c;
                                                            }
                                                        })



                                                        if(column.displayName === 'preview'){
                                                            if(this.currentStatus === 'Deleted')
                                                                return <td key={"preview-" + this.getColumnValue(invoice, column)}></td>

                                                            return  <td key={"preview-" + this.getColumnValue(invoice, column)}> 
                                                                        <InvoicePreview file_name={this.getColumnValue(invoice, column)} currentInvoice={this.state.currentInvoice} />
                                                                    </td>
                                                        }
                                                            
                                                        if(column.displayName === 'comments')
                                                           return <td className="col-md-1" onClick={openInvoice} key={"body" + column.displayName} >
                                                               <HoverInfoCard info={this.getColumnValue(invoice, column)}/>
                                                                 </td>

                                                        if (column.displayName === 'payment_status')
                                                            return (
                                                                <td className=""
                                                                    onClick={openInvoice}
                                                                    key={"body" + column.displayName}>
                                                                    {this.getPaymentColumnInfoCard(invoice, column)}
                                                                </td>
                                                            );

                                                        if (column.displayName === 'status') 
                                                            return (
                                                                <td onClick={openInvoice} key={"body" + column.displayName} className={"invoice-row-status-" + invoice.status.toLowerCase()}>
                                                                    {!canOpenInvoice && <FontAwesomeIcon className="mr-2 text-secondary infinite-rotate faded" icon={faSync} />}
                                                                    {this.props.data.t.read(`status.${this.getColumnValue(invoice, column).toLowerCase()}`) || this.getColumnValue(invoice, column)}
                                                                </td>
                                                            );

                                                        return (
                                                                <td onClick={openInvoice} key={"body" + column.displayName}>
                                                                    {this.getColumnValue(invoice, column)}
                                                                </td>
                                                            );
                                                    })
                                                }
                                                <td></td>
                                            </tr>
                                        );
                                    }
                                    else {
                                        return null;
                                    }
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                this.state.currentInvoice != null ?
                    <div className="overlay" onClick={() => this.closeInvoicePrompt(false)}>
                        <div className="overlay-content">
                            <div className="invoice-container" onClick={stopClickReachingOverlay}>
                                <Invoice id={this.state.currentInvoice} invoices={this.state.invoices} close={mustRefresh => this.closeInvoicePrompt(mustRefresh)} />
                            </div>
                        </div>
                    </div>
                    :
                    <div className="d-flex justify-content-center">
                        <ul className="pagination">
                            <li className={this.state.pageNumber <= 1 ? "page-item disabled" : "page-item"}><p className="page-link" onClick={() => this.handlePageChange(this.state.pageNumber - 1)}>{this.props.data.t.read("previous_page")}</p></li>
                            {this.renderPagination()}
                            <li className={this.state.pageNumber >= this.state.pageCount ? "page-item disabled" : "page-item"}><p className="page-link" onClick={() => this.handlePageChange(this.state.pageNumber + 1)}>{this.props.data.t.read("next_page")}</p></li>
                        </ul>
                    </div>
            }
        </div>
        
    }

    
})));
